
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import TicketRepositoryInterface, { TicketInterface } from '@/services/QC-V2/ticket/interfaces';
import TicketsRows from '@/components/qa/ticket/TicketsTable.vue';
import { UserRepoInterface } from '@/services/Users/Interfaces';
import { FilterRequestData } from '@/services/QC-V2/chat/interfaces';
import TicketsFilters, { FilterInterface } from '@/components/qa/ticket/TicketsFilters.vue';
import TicketsTable from '@/components/qa/ticket/TicketsTable.vue';

@Component({
  components: { TicketsTable, TicketsFilters, TicketsRows },
  mixins: [
    Themeable,
  ],
  inject: [
    'ticketRepositoryV2',
    'userRepository',
  ],
})
export default class Queue extends Vue {
  public $refs!: {
    ticketsCol: HTMLFormElement,
    row: HTMLFormElement,
  };

  private ticketRepositoryV2!: TicketRepositoryInterface;
  private userRepository!: UserRepoInterface;

  private loading: boolean = true;
  private tickets: TicketInterface[] = [];
  private ticket: TicketInterface = {} as TicketInterface;
  private disabledTickets: { [key: number]: string[] } = [];
  private totalItems: number = 0;

  private filtersData: FilterInterface[] = [];
  private filter: FilterRequestData = { page: 1 };

  private get windowHeight(): number {
    return this.$refs.ticketsCol.clientHeight - 60;
  }

  private async created(): Promise<void> {
    try {
      await this.initialize();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  private async initialize(): Promise<void> {
    try {
      [this.tickets, this.totalItems] = await this.ticketRepositoryV2.getTicketQueue(this.filter);
      await this.verifyAgents();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  private async changePage(page: number): Promise<void> {
    if (this.filter.page === page) {
      return;
    }

    this.filter.page = page;
    await this.initialize();
  }

  private async filterTickets(filter: FilterRequestData, filtersData: FilterInterface[]): Promise<void> {
    this.filter = filter;
    this.filtersData = filtersData;
    this.filter.page = 1;
    await this.initialize();
  }

  private getTicket(id: number): void {
    const route = this.$router.resolve({ name: 'ticket', params: { ticketId: String(id) } });
    window.open(route.href, '_blank');
  }

  private async verifyAgents(): Promise<void> {
    const ticketsMap: { [ticketId: number]: string[] } = {};
    let emails: string[] = [];
    this.tickets.forEach((ticket) => {
      const ticketAgentEmails = ticket.agents.map((agent) => agent.email);
      ticketsMap[ticket.id] = ticketAgentEmails;
      emails.push(...ticketAgentEmails);
    });

    emails = emails.filter((email, index, self) => self.indexOf(email) === index);
    const users = await this.userRepository.getUsersByEmails(emails);
    const usersEmails = users.map((user) => user.email);

    Object.keys(ticketsMap).forEach((key) => {
      ticketsMap[Number(key)].forEach((email) => {
        if (usersEmails.includes(email)) {
          return;
        }
        if (!this.disabledTickets[Number(key)]) {
          this.disabledTickets[Number(key)] = [];
        }

        if (this.disabledTickets[Number(key)].includes(email)) {
          return;
        }

        this.disabledTickets[Number(key)].push(email);
      });
    });
  }

  private async closeTicket(): Promise<void> {
    delete this.$route.params.ticketId;
    await this.$router.push({ name: 'tickets_queue' });
    this.ticket = {} as TicketInterface;
  }
}
